import LegalLayout from './LegalLayout';

export default function Privacy() {
  return (
    <LegalLayout
      title="Политика обработки персональных данных"
      updatedAt="9 сентября 2026 года"
    >
      <p>
        Настоящая Политика разработана в&nbsp;соответствии с&nbsp;Федеральным законом
        от&nbsp;27.07.2006&nbsp;№&nbsp;152-ФЗ «О&nbsp;персональных данных»
        и&nbsp;определяет порядок обработки персональных данных, обязательства
        и&nbsp;меры защиты, которые принимает Оператор.
      </p>

      <h2>1. Оператор</h2>
      <p>
        Оператором персональных данных является:
      </p>
      <ul>
        <li>Индивидуальный предприниматель Раджабов Рустам Эфлетдинович;</li>
        <li>ИНН&nbsp;051707862851;</li>
        <li>Email: <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>;</li>
        <li>Телефон: <a href="tel:+79894734322">+7&nbsp;989&nbsp;473-43-22</a>.</li>
      </ul>

      <h2>2. Какие данные мы&nbsp;обрабатываем</h2>
      <h3>2.1. От&nbsp;Заказчиков (владельцев заведений и&nbsp;их&nbsp;сотрудников):</h3>
      <ul>
        <li>фамилия, имя, отчество (при наличии);</li>
        <li>адрес электронной почты, номер телефона;</li>
        <li>реквизиты заведения: наименование, адрес, ИНН;</li>
        <li>идентификатор платёжного метода через ЮKassa (мы&nbsp;не&nbsp;храним номер карты);</li>
        <li>логи действий в&nbsp;административной панели и&nbsp;кассовом приложении;</li>
        <li>IP-адрес и&nbsp;технические данные устройства.</li>
      </ul>

      <h3>2.2. От&nbsp;гостей (пользователей электронного меню):</h3>
      <ul>
        <li>обезличенные данные о&nbsp;заказе: блюда, стол, сумма, способ оплаты;</li>
        <li>имя и&nbsp;адрес электронной почты, только при добровольной регистрации в&nbsp;меню;</li>
        <li>технические данные: IP-адрес, идентификатор сессии, модель устройства.</li>
      </ul>

      <h3>2.3. От&nbsp;гостей, пользователей мобильного приложения Resstro:</h3>
      <ul>
        <li>адрес электронной почты: для входа по&nbsp;одноразовому коду и&nbsp;уведомлений о&nbsp;заказах;</li>
        <li>имя и&nbsp;номер телефона (по&nbsp;желанию): чтобы заведение могло обратиться к&nbsp;гостю по&nbsp;заказу или брони;</li>
        <li>сохранённые адреса: чтобы показывать заведения рядом с&nbsp;выбранной точкой;</li>
        <li>геолокация устройства: только с&nbsp;разрешения гостя и&nbsp;только для сортировки заведений по&nbsp;расстоянию; координаты обрабатываются на&nbsp;устройстве и&nbsp;передаются Оператору лишь в&nbsp;составе сохранённого адреса;</li>
        <li>история заказов и&nbsp;бронирований: заведение, блюда, сумма, способ оплаты, время визита;</li>
        <li>оценки и&nbsp;отзывы о&nbsp;заказах: публикуются в&nbsp;приложении с&nbsp;указанием имени гостя;</li>
        <li>идентификатор устройства для push-уведомлений (APNs-токен): для сообщений о&nbsp;статусе заказа и&nbsp;напоминаний о&nbsp;брони; отключается в&nbsp;настройках устройства;</li>
        <li>технические данные: версия приложения и&nbsp;операционной системы, IP-адрес.</li>
      </ul>
      <p>
        Приложение не&nbsp;использует рекламные идентификаторы и&nbsp;не&nbsp;отслеживает
        пользователя в&nbsp;приложениях и&nbsp;на&nbsp;сайтах третьих лиц. Данные банковских карт
        вводятся на&nbsp;защищённой странице ЮKassa и&nbsp;Оператору не&nbsp;передаются.
        Учётную запись вместе с&nbsp;контактами, адресами и&nbsp;push-подписками гость может
        удалить самостоятельно: Профиль&nbsp;→ «Удалить аккаунт».
      </p>

      <h2>3. Цели и&nbsp;правовые основания</h2>
      <p>
        Обработка осуществляется на&nbsp;следующих основаниях (ст.&nbsp;6 152-ФЗ):
      </p>
      <ul>
        <li>заключённый договор-оферта и&nbsp;его исполнение;</li>
        <li>согласие субъекта данных, оформленное в&nbsp;виде отдельного документа
          (см.{' '}
          <a href="/legal/consent">Согласие на&nbsp;обработку</a>
          );
        </li>
        <li>исполнение требований законодательства РФ (54-ФЗ, налоговый учёт);</li>
        <li>защита прав и&nbsp;законных интересов Оператора.</li>
      </ul>
      <p>Цели обработки:</p>
      <ul>
        <li>предоставление и&nbsp;улучшение функций Сервиса;</li>
        <li>биллинг подписки и&nbsp;фискализация продаж;</li>
        <li>техническая поддержка и&nbsp;сервисная коммуникация;</li>
        <li>защита Сервиса от&nbsp;злоупотреблений и&nbsp;мошенничества;</li>
        <li>информационные рассылки: только при отдельном согласии.</li>
      </ul>

      <h2>4. Передача данных третьим лицам</h2>
      <p>
        Данные передаются только нижеперечисленным обработчикам в&nbsp;объёме, необходимом
        для оказания услуг. Полный список доступен по&nbsp;запросу на&nbsp;
        <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>:
      </p>
      <ul>
        <li><strong>НКО «ЮMoney» (ЮKassa)</strong>: приём платежей, выпуск чеков;</li>
        <li><strong>Оператор фискальных данных</strong>: передача чеков в&nbsp;ФНС;</li>
        <li><strong>Облачный провайдер на&nbsp;территории РФ</strong>: хостинг Сервиса.</li>
      </ul>
      <p>
        Трансграничная передача персональных данных не&nbsp;осуществляется. Все базы данных
        хранятся на&nbsp;серверах, расположенных на&nbsp;территории Российской Федерации
        (требование ч.&nbsp;5 ст.&nbsp;18 152-ФЗ).
      </p>
      <p>
        Мы&nbsp;не&nbsp;передаём и&nbsp;не&nbsp;продаём персональные данные третьим лицам
        для маркетинговых целей.
      </p>

      <h2>5. Сроки хранения</h2>
      <ul>
        <li>данные учётной записи Заказчика: в&nbsp;течение действия подписки и&nbsp;6&nbsp;месяцев после её&nbsp;завершения;</li>
        <li>данные о&nbsp;расчётах и&nbsp;чеках: не&nbsp;менее 5&nbsp;лет (требование 54-ФЗ);</li>
        <li>данные гостей в&nbsp;электронном меню и&nbsp;мобильном приложении: до&nbsp;момента отзыва согласия или удаления учётной записи (сведения о&nbsp;совершённых заказах сохраняются в&nbsp;обезличенном виде в&nbsp;сроки, установленные 54-ФЗ);</li>
        <li>логи входа и&nbsp;аудит: не&nbsp;более 12&nbsp;месяцев.</li>
      </ul>

      <h2>6. Меры защиты</h2>
      <ul>
        <li>передача данных защищена TLS&nbsp;1.3;</li>
        <li>пароли хранятся в&nbsp;виде криптостойкого хэша (bcrypt);</li>
        <li>резервное копирование базы данных выполняется ежедневно;</li>
        <li>доступ к&nbsp;административным инструментам ограничен по&nbsp;IP и&nbsp;многофакторной аутентификации;</li>
        <li>применяются организационные меры в&nbsp;соответствии с&nbsp;Приказом ФСТЭК России №&nbsp;21.</li>
      </ul>
      <p>
        В&nbsp;случае инцидента, повлёкшего нарушение прав субъектов персональных данных,
        Оператор уведомит Роскомнадзор в&nbsp;течение 24&nbsp;часов с&nbsp;момента обнаружения
        (требование, действующее с&nbsp;30.05.2025).
      </p>

      <h2>7. Права субъекта персональных данных</h2>
      <p>
        В&nbsp;соответствии со&nbsp;ст.&nbsp;14 152-ФЗ вы&nbsp;вправе:
      </p>
      <ul>
        <li>получить сведения о&nbsp;факте, целях и&nbsp;способах обработки своих данных;</li>
        <li>требовать уточнения, блокирования или удаления данных;</li>
        <li>отозвать согласие на&nbsp;обработку в&nbsp;любой момент;</li>
        <li>обжаловать действия Оператора в&nbsp;Роскомнадзоре или в&nbsp;суде.</li>
      </ul>
      <p>
        Любое из&nbsp;этих прав реализуется по&nbsp;письменному запросу на&nbsp;
        <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>. Срок ответа:
        не более 10&nbsp;рабочих дней.
      </p>

      <h2>8. Файлы cookies</h2>
      <p>
        Условия использования cookies и&nbsp;управление выбором описаны в&nbsp;
        <a href="/legal/cookies">отдельной политике cookies</a>.
      </p>

      <h2>9. Изменения политики</h2>
      <p>
        Актуальная редакция всегда доступна по&nbsp;адресу&nbsp;
        <a href="https://resstro.ru/legal/privacy">resstro.ru/legal/privacy</a>.
        О&nbsp;существенных изменениях мы&nbsp;уведомим в&nbsp;кабинете и&nbsp;по&nbsp;электронной почте.
      </p>

      <h2>10. Жалобы и&nbsp;надзорный орган</h2>
      <p>
        Если вы&nbsp;считаете, что обработка ваших данных нарушает закон, вы&nbsp;можете
        обратиться в&nbsp;Управление Роскомнадзора по&nbsp;месту жительства или
        в&nbsp;центральный аппарат: <a href="https://rkn.gov.ru" target="_blank" rel="noopener noreferrer">rkn.gov.ru</a>.
      </p>
    </LegalLayout>
  );
}
